import React from 'react';
import { ShieldCheck, Home, PlugZap } from 'lucide-react';
import { commissions } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const iconMap = {
  'shield-check': ShieldCheck,
  'home': Home,
  'plug-zap': PlugZap
};

const Commissions = () => {
  const handleContactTechnicalReport = () => {
    const subject = "Parecer técnico / viabilidade EV";
    const message = encodeURIComponent(`Olá! Gostaria de conversar sobre ${subject}.`);
    const whatsappUrl = `https://wa.me/5511984845464?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'contact', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="comissoes" className="section-padding section-bg">
      <div className="container-custom">
        <h2 className="section-title">Atuação em Comissões e Comunidades</h2>
        
        <div className="experience-grid">
          {commissions.map((item) => {
            const IconComponent = iconMap[item.icon] || iconMap["shield"];;
            return (
              <div key={item.id} className="experience-card">
                <div className="experience-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="experience-title">{item.title}</h3>
                <p className="experience-description">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="experience-cta">
          <button onClick={handleContactTechnicalReport} className="btn-secondary">
            Quero um parecer técnico
          </button>
        </div>
      </div>
    </section>
  );
};

export default Commissions;
